import { useEffect, useRef } from "react";
import { QUADRI } from "../../content/copy";
import { Reveal } from "../Reveal";
import { SectionMark, RegMarks } from "../fx/Marginalia";

const META = [
  ["T+ 0,000 s", "FAGLIA / TEMPO"],
  ["T+ 0,900 s", "ZONA / DEFORMAZIONE"],
  ["T+ 40,000 s", "FATICA / RESIDUA"],
];

const Readout = () => (
  <div className="rq mono" aria-hidden="true" data-testid="quadro-1-readout">
    <div className="rq-row"><span>IMPULSO NERVOSO</span><span className="rq-val">100 m/s</span></div>
    <span className="rq-bar"><span className="rq-fill rq-slow" /></span>
    <div className="rq-row"><span>FIBRA OTTICA</span><span className="rq-val">200.000 km/s</span></div>
    <span className="rq-bar"><span className="rq-fill" /></span>
    <div className="rq-row rq-delta"><span>Δ ORDINI DI GRANDEZZA</span><span className="rq-val glitch">10<sup>6</sup></span></div>
  </div>
);

const useParallax = (refs) => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let raf = 0;
    const update = () => {
      raf = 0;
      const vh = window.innerHeight;
      refs.current.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        el.style.transform = `translate3d(0, ${(r.top + r.height / 2 - vh / 2) * -0.14}px, 0)`;
      });
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.removeEventListener("scroll", onScroll); cancelAnimationFrame(raf); };
  }, [refs]);
};

export const QuadriBands = () => {
  const refs = useRef([]);
  useParallax(refs);
  return (
    <section className="quadri-sec" data-testid="section-quadri" data-rail="03">
      <div className="frame quadri-head">
        <SectionMark n="03" label="TRE QUADRI" />
      </div>
      {QUADRI.map((q, i) => {
        const [kick, name] = q.title.split(" — ");
        return (
          <article key={q.numeral} className={`band band-${i + 1} ${i % 2 ? "bg-b" : "bg-a"}`} data-testid={`quadro-${i + 1}`}>
            <RegMarks />
            <span ref={(el) => (refs.current[i] = el)} className="band-numeral serif" aria-hidden="true" data-testid={`quadro-numeral-${i + 1}`}>
              {q.numeral}
            </span>
            <div className="frame g12 band-grid">
              <div className="band-meta mono" aria-hidden="true">
                {META[i].map((m) => <span key={m}>{m}</span>)}
              </div>
              <Reveal as="h3" className="q-title" data-testid={`quadro-title-${i + 1}`}>
                <span className="q-kick mono">{kick}</span> <span className="q-dash mono">—</span> <span className="q-name serif">{name}</span>
              </Reveal>
              {i === 0 && <Reveal className="rq-wrap" delay={300}><Readout /></Reveal>}
              <Reveal as="p" className="q-text serif" delay={200} data-testid={`quadro-text-${i + 1}`}>{q.text}</Reveal>
            </div>
          </article>
        );
      })}
    </section>
  );
};
